var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellationReasons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3495_9374)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5469 0.868995C13.2112 0.460769 15.9339 1.0214 18.2207 2.4481C18.9103 2.87832 19.5458 3.3796 20.1201 3.93931C20.1735 3.96347 20.2237 3.99698 20.2676 4.04087C20.3133 4.08665 20.3478 4.13918 20.3721 4.19517C21.5762 5.44592 22.486 6.9654 23.0117 8.64634C23.094 8.90971 22.9478 9.18972 22.6846 9.27232C22.4211 9.35454 22.14 9.20764 22.0576 8.94419C21.6124 7.5209 20.8657 6.2238 19.8818 5.13267L13.0039 12.0106L19.8809 18.8875C20.869 17.7915 21.619 16.4888 22.0635 15.0584C22.1456 14.7951 22.426 14.6476 22.6895 14.7293C22.953 14.8113 23.1003 15.0917 23.0186 15.3553C22.2187 17.9293 20.5224 20.1323 18.2383 21.5633C15.9544 22.994 13.2331 23.5592 10.5684 23.1561C7.9034 22.7528 5.47043 21.4077 3.71192 19.3651C1.95341 17.3224 0.984975 14.7167 0.982427 12.0213C0.979938 9.32604 1.94364 6.71867 3.69825 4.67271C5.45288 2.62689 7.8828 1.27731 10.5469 0.868995ZM5.37598 19.6385C6.86359 20.9799 8.71866 21.8643 10.7178 22.1668C13.1463 22.5343 15.6266 22.0196 17.708 20.7157C18.2336 20.3864 18.7241 20.0107 19.1768 19.5975L12.2969 12.7176L5.37598 19.6385ZM17.6914 3.29575C15.6075 1.99572 13.1261 1.48528 10.6982 1.85728C8.70661 2.16255 6.85938 3.04604 5.37696 4.38267L10.9092 9.91587C11.1044 10.1111 11.1044 10.4276 10.9092 10.6229C10.7139 10.818 10.3974 10.8181 10.2022 10.6229L4.66797 5.08774C4.59695 5.16558 4.52582 5.24387 4.45704 5.32407C2.85821 7.18848 1.98017 9.56429 1.98243 12.0204C1.98475 14.4766 2.86724 16.8513 4.46973 18.7127C4.53415 18.7876 4.60159 18.8597 4.66797 18.9325L19.1777 4.42271C18.7203 4.00527 18.2232 3.62753 17.6914 3.29575Z",
    fill: "#85909F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3495_9374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellationReasons);
export default __webpack_public_path__ + "static/media/cancellationReasons.6c0270a66c2c72dc5d08bf6ebbb8cc7c.svg";
export { ForwardRef as ReactComponent };